<div class="container-fluid p-5">
  <div class="row">
    <div class="col-12 col-sm-10 col-md-8 offset-sm-1 offset-md-2 jumbo">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="k-form-inline">

        <div class="k-form-field">
          <label for="email" class="form-label col-3 k-label">Email</label>
          <div class="col-8">
            <input type="email" id="email" formControlName="email" class="form-control" style="text-transform: lowercase;">
            <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="alert alert-danger">
              <div *ngIf="email?.errors?.['required']">Email address is required.</div>
              <div *ngIf="email?.errors && email?.errors?.['email']">Please, enter valid email address.</div>
            </div>
          </div>
        </div>
        <div class="k-form-field" #appendTo>
          <label for="password" class="form-label col-3 k-label">Password</label>
          <div class="col-8">
            <input type="password" id="password" formControlName="password" class="form-control">
            <div *ngIf="f['password'].touched && f['password'].invalid" class="alert alert-danger">
              <div *ngIf="f['password'].errors && f['password'].errors['required']">Password is required.</div>
            </div>
          </div>
        </div>
        <div class="k-form-field">
          <label class="form-label col-3 k-label"></label>
          <div class="col-8">
            @if(busy){
            <button class="btn btn-primary" disabled="true"><fa-icon [icon]="['fat', 'spinner']"
                animation="spin"></fa-icon> Logging in</button>
            <!-- <button class="btn btn-primary" disabled="true"><fa-icon [icon]="['fat', 'spinner']"
                [spin]="true"></fa-icon> Logging in</button> -->
            } @else {
            <button class="btn btn-primary" type="submit" [disabled]="loginForm.invalid"
              style="margin-right: 5px;">Submit</button>
            }
          </div>
        </div>

        <div class="k-form-field">
          <div class="col-8 offset-md-3">
            <span>Forgot your password? <a routerLink="/reset-password" routerLinkActive="active">Reset
                Password</a>.</span>
          </div>
        </div>

        <div class="k-form-field">
          <div class="col-8 offset-3">
            <span>Don't have an account yet? <a routerLink="/auth-sign-up" class="ulink">Create an account</a>.</span>
          </div>
        </div>

      </form>

    </div>
  </div>
</div>

<div kendoDialogContainer></div>
